import { useDeleteSchemeGiftItem } from "http-hooks/schmitemaster/useSchemeGiftItem";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteSchemeGiftItem({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteSchemeGiftItem();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Scheme Gift Item"
      description="Are you sure you want to delete this scheme gift item? This item will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
